export const testQuestionSingleResourceType = "test_question_single" as const;
